import clubsConfig from '@/common/pdcClubsJsonConfig.json';

const COCO_SLUG = 'coco-bongo-playa-del-carmen';
const ILIOS_SLUG = 'ilios-playa-del-carmen';
const PORFIRIOS_SLUG = 'porfirios-playa-del-carmen';
const VICENTA_SLUG = 'la-vicenta-playa-del-carmen';
const SPEAK_SLUG = 'speakeasy-playa-del-carmen';
const ONHEAVEN_SLUG = 'on-heaven-playa-del-carmen';
const MARTINA_SLUG = 'martina-beach-club-playa-del-carmen';


function slugDecoder(slug) {
  return slug ? slug.split('-')[0] : '';
}

function venueDecoder(slugOrTitle) {
  let venue = '';
  if(slugOrTitle.indexOf('@') > -1) {
    venue = slugOrTitle.split('@')[1];

  } else {
    return  clubsConfig[slugOrTitle];
  }

  const venueMatch = venue.toLowerCase();

  let venueConfigMap = {
    'coco.bongo': COCO_SLUG,
    'ilios': ILIOS_SLUG,
    'porfirios': PORFIRIOS_SLUG,
    'vicenta': VICENTA_SLUG,
    'heaven': ONHEAVEN_SLUG,
    'speakeasy': SPEAK_SLUG,
    'martina': MARTINA_SLUG,
  }

  for (const key in venueConfigMap) {
    if (venueMatch.match(key)) {
      return clubsConfig[venueConfigMap[key]] || { title };
    }
  }
  console.error('pdc venue decoder: venue not found:' + slugOrTitle );
  return { title: '', address: {} };
}

export { venueDecoder, slugDecoder };
